import React, { Suspense } from 'react'
import { LoadingComponent } from '../../loading/index'

const Table = React.lazy(() => import('./table'))

const AsyncTable = props => (
  <Suspense fallback={<LoadingComponent />}>
    <Table {...props} />
  </Suspense>
)

export default AsyncTable
